import { Component, inject, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-pi-attestation-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatRadioModule,
    MatCheckboxModule,
    MatIconModule,
  ],
  templateUrl: './pi-attestation-modal.component.html',
  styleUrls: ['./pi-attestation-modal.component.css'],
})
export class PiAttestationModalComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<PiAttestationModalComponent>);

  piAudit = false;
  oncDirectReview: 'yes' | 'no' | null = null;
  interoperability: 'yes' | 'no' | null = null;
  securityRiskAnalysis: 'yes' | 'no' | null = null;
  securityRiskAnalysisImplemented: 'yes' | 'no' | null = null;
  saferGuides: 'yes' | 'no' | null = null;
  performanceYear: number = 2025;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    if (this.data) {
      const toYesNo = (val: any): 'yes' | 'no' | null => {
        if (val === true || val === 'yes') return 'yes';
        if (val === false || val === 'no') return 'no';
        return null;
      };

      this.performanceYear = this.data.performanceYear ?? 2025;
      this.piAudit = this.data.piAuditAttestation === true;
      this.oncDirectReview = toYesNo(this.data.oncDirectReview);
      this.interoperability = toYesNo(this.data.interoperabilityAttestation);
      this.securityRiskAnalysis = toYesNo(this.data.securityRiskAnalysis);
      this.securityRiskAnalysisImplemented = toYesNo(this.data.securityRiskAnalysisImplemented);
      this.saferGuides = toYesNo(this.data.saferGuidesAttestation);
    }
  }

  get isYear2026Plus(): boolean {
    return this.performanceYear >= 2026;
  }

  get canSave(): boolean {
    const baseAnswered =
      this.piAudit === true &&
      this.oncDirectReview !== null &&
      this.interoperability !== null &&
      this.securityRiskAnalysis !== null &&
      this.saferGuides !== null;

    if (this.isYear2026Plus) {
      return baseAnswered && this.securityRiskAnalysisImplemented !== null;
    }
    return baseAnswered;
  }

  get allAnsweredYes(): boolean {
    const baseYes =
      this.piAudit === true &&
      this.oncDirectReview === 'yes' &&
      this.interoperability === 'yes' &&
      this.securityRiskAnalysis === 'yes' &&
      this.saferGuides === 'yes';

    if (this.isYear2026Plus) {
      return baseYes && this.securityRiskAnalysisImplemented === 'yes';
    }
    return baseYes;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  save(): void {
    if (this.canSave) {
      this.dialogRef.close({
        piAuditAttestation: this.piAudit,
        oncDirectReview: this.oncDirectReview,
        interoperabilityAttestation: this.interoperability,
        securityRiskAnalysis: this.securityRiskAnalysis,
        securityRiskAnalysisImplemented: this.isYear2026Plus ? this.securityRiskAnalysisImplemented : null,
        saferGuidesAttestation: this.saferGuides,
        allYes: this.allAnsweredYes,
      });
    }
  }
}
